//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import HiddenField from "./hidden";
export default {
  // components: {
  //   "fields-hidden": HiddenField
  // },
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      anyChecked: false,
      errorMessage: null,
      rules: [function (_v) {
        return _this.anyChecked || _this.errorMessage || true;
      }]
    };
  },
  // computed: {
  //   uncheckSpec() {
  //     return { name: this.spec.name, value: this.spec.uncheckValue };
  //   }
  // },
  methods: {
    $ready: function $ready() {
      var _this2 = this;

      var validation = this.spec.validation || {};
      Utils.type.ifObject(validation.required, function (required) {
        _this2.errorMessage = required.message;
      });
      this.detectChecked();
      var vm = this;
      this.$el.addEventListener("change", function (e) {
        vm.detectChecked();
      }, false);
    },
    detectChecked: function detectChecked() {
      this.anyChecked = false;
      var vm = this;
      this.$el.querySelectorAll("input[type=checkbox]").forEach(function (checkbox) {
        if (checkbox.checked) {
          vm.anyChecked = true;
          return;
        }
      });
    },
    childSpec: function childSpec(item) {
      if (this.spec.readOnly) {
        return Object.assign(item, {
          readOnly: this.spec.readOnly
        });
      }

      return item;
    }
  }
};